import React, { useState } from 'react';
import { SimulatorOfferModel, DiscountModel, YesNo, RiderPackageModel, RiderPackageServiceModel, RiderServiceCompany, RiderService, RiderComapny } from '../models/superbit-api-models'
import { StatOptions } from 'fs';
import moment from 'moment';
import { MigdalDiscount } from './_MigdalDiscount';
import { Tooltip } from 'antd';
type Props = {
  rider: any;
  onChanged: any;
  checked?: boolean;
  recommendedCost?: number;
};

type State = {
  rider: any;
  onChanged: any;
  over: boolean;
  recommendedCostErr: string
};




export class OfferRider extends React.Component<Props, State> {
  constructor(props: any) {
    super(props);

    this.state = {
      rider: this.props.rider,
      onChanged: null,
      over: false,
      recommendedCostErr: ""
    }

    this.updateFromProps();

  }

  updateFromProps = async () => {
    const data = this.state.rider;

    if (this.props.checked && this.props.checked == true)
      data.autoActive = YesNo._0;

    if (this.props.recommendedCost && this.props.recommendedCost > 0)
      data.recommendedCost = this.props.recommendedCost;
    await this.setState({ rider: data });
  }



  setAutoActive = async (name: string, event: any) => {
    const data = this.state.rider;

    if (event.currentTarget.checked)
      data.autoActive = YesNo._0;
    else
      data.autoActive = YesNo._1;
    await this.setState({ rider: data });
    this.props.onChanged(data);

  }

  setStateInputData = async (name: string, event: any) => {
    const data = this.state.rider;
    data[name] = event.currentTarget.value;
    await this.setState({ rider: data });
    this.props.onChanged(data);
  }

  setRecommendedCost = async (name: string, event: any) => {
    const data = this.state.rider;

    data.recommendedCost = parseInt(event.currentTarget.value);
    if (data.recommendedCost < data.agentCost) {
      await this.setState({ recommendedCostErr: "מחיר נמוך לסוכן" });
    }

    else if (data.recommendedCost < 150) {
      await this.setState({ recommendedCostErr: "מחיר נמוך מ150 שח" });
    }
    else {
      await this.setState({ recommendedCostErr: "" });
    }

    await this.setState({ rider: data });
    this.props.onChanged(data);
  }


  toggleInfo = async () => {
    var over = !this.state.over;
    // if(over) {
    //     over = false;
    // } else {
    //     over = true;
    // }
    await this.setState({ over: over });
  }



  render() {



    return (<>
      <div className="form-table-row flex-space-between flex-centered">
        <div className="form-table-column">
          <input type="checkbox" onChange={(e: any) => this.setAutoActive("autoActive", e)} checked={this.state.rider.autoActive == YesNo._0} />
          <label>{this.state.rider.name}</label>
        </div>
        <div className={this.state.rider && this.state.rider.recommendedCost < this.state.rider.agantCost ? "" : "hide"}>מחיר נמוך לסוכן</div>

        <div className="form-table-column relative">
          <div className="input-row">
            <div className={this.state.rider.autoActive == YesNo._1 ? "input-wrapper flex-space-between flex-centered disabled" : "input-wrapper flex-space-between flex-centered"}>
              <input type="number" disabled={this.state.rider.autoActive == YesNo._1} value={this.state.rider.recommendedCost} onChange={(e: any) => this.setRecommendedCost("recommendedCost", e)} />
              <div className="grey-cell">
                ₪
              </div>

            </div>

          </div>
          <div className='error-message'>{this.state.recommendedCostErr}</div>

        </div>
        <div className="form-table-column tooltip-holder">
          <div className="input-row">

            {/* <div className='icon info pointer'></div> */}
            {/* <Tooltip title={this.props.lead.lead.internalComment} color={'#027BFD'} placement="right">
                                                    
                                              </Tooltip> */}
            <div className="grey-cell" onMouseOver={(e: any) => this.toggleInfo()} onMouseOut={(e: any) => this.toggleInfo()}>
              i
            </div>
          </div>


          <div className={this.state.over ? "rider-info tooltip" : "hide"}   >
            {this.state.rider.riderPackageServices.map((item: RiderPackageServiceModel) => <div >
              {item.riderServiceCompany && item.riderServiceCompany.riderService ? item.riderServiceCompany.riderService.title : ""} -
              {item.riderServiceCompany && item.riderServiceCompany.riderComapny ? item.riderServiceCompany.riderComapny.name : ""}
            </div>)}
          </div>




        </div>
      </div>
    </>
    );
  }
}
